/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Valeur d'essai d'une variable de la formule.
 * @export
 * @interface TestExpressionVariableDto
 */
export interface TestExpressionVariableDto {
    /**
     * 
     * @type {string}
     * @memberof TestExpressionVariableDto
     */
    code: string;
    /**
     * 
     * @type {number}
     * @memberof TestExpressionVariableDto
     */
    value: number;
}

/**
 * Check if a given object implements the TestExpressionVariableDto interface.
 */
export function instanceOfTestExpressionVariableDto(value: object): value is TestExpressionVariableDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function TestExpressionVariableDtoFromJSON(json: any): TestExpressionVariableDto {
    return TestExpressionVariableDtoFromJSONTyped(json, false);
}

export function TestExpressionVariableDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestExpressionVariableDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'value': json['value'],
    };
}

export function TestExpressionVariableDtoToJSON(json: any): TestExpressionVariableDto {
    return TestExpressionVariableDtoToJSONTyped(json, false);
}

export function TestExpressionVariableDtoToJSONTyped(value?: TestExpressionVariableDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'value': value['value'],
    };
}

